/// <reference types="@angular/localize" />

import {bootstrapApplication} from '@angular/platform-browser';
import {RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules} from '@angular/router';
import {IonicRouteStrategy, provideIonicAngular} from '@ionic/angular/standalone';
import {routes} from './app/app.routes';
import {AppComponent} from './app/app.component';
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {errorInterceptor} from "./app/interceptors/error.interceptor";
import {authInterceptor} from "./app/interceptors/auth.interceptor";
import {ApiConfiguration} from "./app/api/api-configuration";
import {environment} from "./environments/environment";
import {loadingInterceptor} from "./app/interceptors/loading.interceptor";
import {clearToastInterceptor} from "./app/interceptors/clear-toast.interceptor";
import {connectionUnavailableInterceptor} from "./app/interceptors/connection-unavailable.interceptor";
import {serviceUnavailableInterceptor} from "./app/interceptors/service-unavailable.interceptor";
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {provideAppInitializer, provideZoneChangeDetection, inject} from '@angular/core';
import {BackendTranslationsService} from './app/services/backend-translations.service';
import {getMessaging, provideMessaging} from "@angular/fire/messaging";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import './app/shared/smzh-kit/register-smzh-kit';
import {CampaignAttributionService} from './app/services/campaign-attribution.service';

// LOCALE_ID is supplied by the localized build (angular.json > i18n), so it must
// not be provided here. Only the source locale's CLDR data needs registering;
// Angular ships `en` by default.
registerLocaleData(localeDe);

bootstrapApplication(AppComponent, {
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideMessaging(() => getMessaging()),
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular({
      rippleEffect: false,
      mode: 'md'
    }),
    provideZoneChangeDetection(),
    // read deep-link campaign values before the first navigation,
    // so authGuard's redirect to /login cannot drop them.
    provideAppInitializer(() => {
      const attribution = inject(CampaignAttributionService);
      attribution.captureFromUrl();
      attribution.stripFromAddressBar();
    }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor, connectionUnavailableInterceptor, serviceUnavailableInterceptor, errorInterceptor, loadingInterceptor, clearToastInterceptor])),
    // Display text for the keys the backend sends (CLP-1364). Loaded before
    // the first screen so no field ever renders its key or the wrong language.
    provideAppInitializer(() => inject(BackendTranslationsService).load()),
    {
      provide: ApiConfiguration,
      useFactory: () => {
        const config = new ApiConfiguration();
        config.rootUrl = environment.apiUrl;
        return config;
      }
    }]
});
